module.exports = __webpack_public_path__ + "img/ff3.dbbb756c.png";